import { createActionCreator, createReducer } from 'deox';
import { Draft, produce } from 'immer';
import { AppState, ToolName } from 'types/AppState';

type TemplateToolFilters = {
  size: string;
};

type MusicToolFilters = {
  tag: string;
};

export type Filters = {
  [ToolName.Template]: TemplateToolFilters;
  [ToolName.Music]: MusicToolFilters;
};

const defaultState: Filters = {
  [ToolName.Template]: { size: 'all_templates' },
  [ToolName.Music]: { tag: null }
};

export const applyTemplateSizeFilter = createActionCreator(
  'FILTERS/APPLY_TEMPLATE_SIZE',
  resolve => (value: TemplateToolFilters['size']) => resolve(value)
);
export const applyMusicTagFilter = createActionCreator(
  'FILTERS/APPLY_MUSIC_TAG',
  resolve => (value: MusicToolFilters['tag']) => resolve(value)
);

export const filters = createReducer(defaultState, handle => [
  handle(
    applyTemplateSizeFilter,
    produce<(d: Draft<Filters>, a: ReturnType<typeof applyTemplateSizeFilter>) => void>(
      (draft, { payload }) => {
        draft[ToolName.Template] = { ...draft[ToolName.Template], size: payload };
      }
    )
  ),
  handle(
    applyMusicTagFilter,
    produce<(d: Draft<Filters>, a: ReturnType<typeof applyMusicTagFilter>) => void>(
      (draft, { payload }) => {
        draft[ToolName.Music] = { ...draft[ToolName.Music], tag: payload };
      }
    )
  )
]);

export const getTemplateSizeFilter = (state: AppState) => state.filters[ToolName.Template].size;
export const getMusicTagFilter = (state: AppState) => state.filters[ToolName.Music].tag;
